import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import useAuth from "hooks/useAuth";
import { IconBrandFacebook, IconDashboard, IconLogout } from "@tabler/icons";
import { Link } from "react-router-dom";

import { APPBAR_DESKTOP, APPBAR_MOBILE } from "components/data/constrain";
import { Container } from "@mui/system";

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: theme.palette.primary[500],
  width: "100%",
  "@media print": {
    display: "none",
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  color: "#fff",
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: 0,
  },
}));

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <RootStyle>
      <Container>
        <ToolbarStyle>
          <Typography variant="h6" sx={{ fontSize: 19, flexGrow: 1 }}>
            <Link to="/">NEPTUNE DEVELOPMENT LTD</Link>
          </Typography>
          {user ? (
            <>
              <Button
                startIcon={<IconDashboard stroke={1.5} size={20} />}
                sx={{ fontSize: "1rem", fontWeight: "normal" }}
              >
                <Link to="/admin/dashboard">Dashboard</Link>
              </Button>

              <Button
                startIcon={<IconLogout stroke={1.5} size={20} />}
                sx={{ fontSize: "1rem", fontWeight: "normal" }}
                onClick={logout}
              >
                logout
              </Button>
            </>
          ) : (
            <Button
              startIcon={<IconLogout stroke={1.5} size={20} />}
              sx={{ p: 0, fontSize: "1rem", fontWeight: "normal" }}
            >
              <Link to="/login">Login</Link>
            </Button>
          )}
          <Button
            sx={{ p: 0 }}
            target="_blank"
            component="a"
            href="https://www.facebook.com/neptunedevelopmentofficial"
          >
            <IconBrandFacebook stroke={1.3} />
          </Button>
        </ToolbarStyle>
      </Container>
    </RootStyle>
  );
}
